// extracted by mini-css-extract-plugin
export default {"rules_view":"TransformRulesView_rules_view__3wwMs","bullet":"TransformRulesView_bullet__XeakV","transform_rules_container":"TransformRulesView_transform_rules_container__19z8N"};